export type SignatoryRole = "vet" | "responsible";

/**
 * Required signatories are derived from which signature tokens the term content
 * contains (see the `signature` category in `src/lib/terms/config.ts`):
 * `{ASSINATURA_VETERINARIO}` and `{ASSINATURA_RESPONSAVEL}`.
 *
 * The vet always signs first (order matters for the co-signature flow: the vet
 * signs in-app when generating the term, then the responsável signs remotely).
 *
 * NOTE: mirrored in `supabase/functions/_shared/term-signature.ts` because Deno
 * edge functions cannot import from `src/`. Keep the two in sync.
 */
export function deriveRequiredSignatories(content: string): SignatoryRole[] {
  const roles: SignatoryRole[] = [];
  if (content.includes("{ASSINATURA_VETERINARIO}")) roles.push("vet");
  if (content.includes("{ASSINATURA_RESPONSAVEL}")) roles.push("responsible");
  return roles;
}
